/**
 * © 2025 Grupo Salamander SAPI de CV
 *
 * MuiBadge component overrides for the Renaissance design system.
 * Provides custom color variants (purple, cyan, teal) that extend
 * the standard MUI Badge color palette.
 */

import type { TPaletteDefinition } from '../palette'
import { onAccent } from '../hyper'

export function badgeOverrides(palette: TPaletteDefinition) {
  return {
    MuiBadge: {
      variants: [
        {
          props: { color: 'purple' as const },
          style: {
            '& .MuiBadge-badge': {
              backgroundColor: palette.purple.main,
              // Real contrast pick (#228), not a hardcoded white — see
              // `onAccent`'s own comment; purple/cyan/teal are all light
              // enough that white only cleared 1.9-4.1:1 against them.
              color: onAccent(palette.purple.main),
            },
          },
        },
        {
          props: { color: 'cyan' as const },
          style: {
            '& .MuiBadge-badge': {
              backgroundColor: palette.cyan.main,
              color: onAccent(palette.cyan.main),
            },
          },
        },
        {
          props: { color: 'teal' as const },
          style: {
            '& .MuiBadge-badge': {
              backgroundColor: palette.teal.main,
              color: onAccent(palette.teal.main),
            },
          },
        },
      ],
    },
  }
}
